import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup, Row, Col } from 'reactstrap';

const BulkScheduleDatesModal = ({ isOpen, toggle, onSave, scheduleId, leagueId }) => {
  const [bulkData, setBulkData] = useState({
    schedule: scheduleId,
    start_date: '',
    end_date: '',
    max_date: '',
    day_of_week: '1' // Monday by default
  });

  const handleSave = () => {
    onSave(bulkData);
    setBulkData({ schedule: scheduleId, start_date: '', end_date: '', max_date: '', day_of_week: '1' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBulkData(prev => ({ ...prev, [name]: value }));
  };

  const getDayName = (day) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[parseInt(day)] || '';
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Bulk Add Schedule Dates</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="start_date">Start Date *</Label>
              <Input
                type="date"
                id="start_date"
                name="start_date"
                value={bulkData.start_date}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="end_date">End Date *</Label>
              <Input
                type="date"
                id="end_date"
                name="end_date"
                value={bulkData.end_date}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label for="max_date">Max Date</Label>
          <Input
            type="date"
            id="max_date"
            name="max_date"
            value={bulkData.max_date}
            onChange={handleChange}
          />
          <small className="text-muted">Optional: Apply this max date to all added dates</small>
        </FormGroup>
        <FormGroup>
          <Label for="day_of_week">Day of Week</Label>
          <Input
            type="select"
            id="day_of_week"
            name="day_of_week"
            value={bulkData.day_of_week}
            onChange={handleChange}
          >
            <option value="0">Sunday</option>
            <option value="1">Monday</option>
            <option value="2">Tuesday</option>
            <option value="3">Wednesday</option>
            <option value="4">Thursday</option>
            <option value="5">Friday</option>
            <option value="6">Saturday</option>
          </Input>
          <small className="text-muted">
            Will add all {getDayName(bulkData.day_of_week)}s between the start and end dates
          </small>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary" 
          onClick={handleSave} 
          disabled={!bulkData.start_date || !bulkData.end_date}
        >
          Add Dates
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BulkScheduleDatesModal;
